import { z } from 'zod';
import { avatarColorSchema } from './primitives';
import { emailSchema, passwordSchema } from './auth';

export const profileSchema = z.object({
  name: z.string().trim().min(2, 'Please enter your name'),
  bio: z.string().max(160, 'Bio must be 160 characters or fewer').optional().default(''),
  avatarColor: avatarColorSchema,
  website: z.string().trim().url('Enter a valid URL').or(z.literal('')).optional(),
  twitter: z.string().trim().max(50).optional().default(''),
  linkedin: z.string().trim().max(100).optional().default(''),
});
export type ProfileInput = z.infer<typeof profileSchema>;

export const accountSchema = z
  .object({
    email: emailSchema,
    currentPassword: z.string().optional().default(''),
    newPassword: z.union([passwordSchema, z.literal('')]).optional().default(''),
    confirmPassword: z.string().optional().default(''),
  })
  .refine((v) => !v.newPassword || v.newPassword === v.confirmPassword, {
    message: "Passwords don't match",
    path: ['confirmPassword'],
  });
export type AccountInput = z.infer<typeof accountSchema>;

export const notificationPrefsSchema = z.object({
  reply: z.boolean(),
  newsletter: z.boolean(),
  newArticle: z.boolean(),
  weeklyDigest: z.boolean(),
});
export type NotificationPrefsInput = z.infer<typeof notificationPrefsSchema>;
